import type {
  CreateGuestProfileRequestDto,
  EnrollGuestLoyaltyRequestDto,
  MergeGuestProfilesRequestDto,
  SyncGuestStayHistoryRequestDto,
  UpdateGuestContactDetailsRequestDto,
  UpdateGuestMarketingRequestDto,
  UpsertGuestPreferenceRequestDto,
} from "./contracts/dtos.ts";
import {
  createGuestProfile,
  enrollGuestLoyalty,
  mergeGuestProfiles,
  syncGuestStayHistory,
  updateGuestContactDetails,
  updateGuestMarketing,
  upsertGuestPreference,
} from "./service.ts";
import type { GuestProfileContext } from "./types.ts";

export const guestProfileManagementEndpoints = {
  createProfile: (
    request: CreateGuestProfileRequestDto,
    context: GuestProfileContext,
    deps: { idFactory: (prefix: string) => string }
  ) => createGuestProfile(request, context, deps),
  updateContactDetails: (
    request: UpdateGuestContactDetailsRequestDto,
    context: GuestProfileContext,
    deps: { idFactory: (prefix: string) => string }
  ) => updateGuestContactDetails(request, context, deps),
  upsertPreference: (
    request: UpsertGuestPreferenceRequestDto,
    context: GuestProfileContext,
    deps: { idFactory: (prefix: string) => string }
  ) => upsertGuestPreference(request, context, deps),
  enrollLoyalty: (
    request: EnrollGuestLoyaltyRequestDto,
    context: GuestProfileContext,
    deps: { idFactory: (prefix: string) => string }
  ) => enrollGuestLoyalty(request, context, deps),
  updateMarketing: (
    request: UpdateGuestMarketingRequestDto,
    context: GuestProfileContext,
    deps: { idFactory: (prefix: string) => string }
  ) => updateGuestMarketing(request, context, deps),
  mergeProfiles: (
    request: MergeGuestProfilesRequestDto,
    context: GuestProfileContext,
    deps: { idFactory: (prefix: string) => string }
  ) => mergeGuestProfiles(request, context, deps),
  syncStayHistory: (
    request: SyncGuestStayHistoryRequestDto,
    context: GuestProfileContext,
    deps: { idFactory: (prefix: string) => string }
  ) => syncGuestStayHistory(request, context, deps),
};
